import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule }    from '@angular/http';
import { ApplicationUrlSettings } from './settings/ApplicationUrlSettings';
import { AppRoutingModule } from './app.routing.module';
import 'hammerjs';
import { AppComponent } from './app.component';
import { VehicleService } from './services/vehicle-service/vehicle.service';
import { UserService} from './services/user-service/user.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CacheService } from './services/cache-service/cache.service';
import { LoginComponent } from './login/login.component';
import { MatButtonModule, MatCardModule, MatCheckboxModule, MatFormFieldModule, MatIconModule, MatInputModule, MatNativeDateModule, MatSlideToggleModule, MatStepperModule, MatToolbarModule, MatExpansionModule } from '@angular/material';
import { DialogModule } from './utilities/Dialog/dialog/dialog.module';
import { CommonComponentsModule } from './common-components/common-components.module';
import { RegisterComponent } from './register/register.component';
import { MainService } from './services/optimizer-service/optimizer.service';
import { QuickAssignment } from './utilities/VehicleAllocation/QuickAssignment';
import { DirectionsService } from './utilities/DirectionsService/DirectionsService';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { DriverRouteComponent } from './admin-dashboard/driver-route/driver-route.component';
import { AdminLoginComponent } from './admin-dashboard/admin-login/admin-login.component';
import { AuthService } from './services/auth-service/auth.service';
import {MatMenuModule} from '@angular/material/menu';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { CompanyService } from './services/company-service/company.service';
import { GAuthorizationCallbackComponent } from './g-authorization-callback/g-authorization-callback.component';
import { DriverRegistrationComponent } from './driver-registration/driver-registration.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { FileService } from './services/file-service/file.service';
import { DriverService } from './services/driver-service/driver.service';
import { DriverGAuthorizationCallbackComponent } from './driver-g-authorization-callback/driver-g-authorization-callback.component';
import { TermsComponent } from './terms/terms.component';
import { RegistrationCompleteComponent } from './registration-complete/registration-complete.component';
import { ClientLoginComponent } from './client-login/client-login.component';
import { SocketService } from './socket.service';
import { TrackingLinkComponent } from './tracking-link/tracking-link.component';
import { ClaimAccountComponent } from './claim-account/claim-account.component';
import { HomeComponent } from './home/home.component';
import { SharedModule } from './shared/shared.module';
import { BookRideComponent } from './book-ride/book-ride.component';
import { SupportComponent } from './support/support.component';
import { StatusUpdateComponent } from './status-update/status-update.component';
import { TrackerComponent } from './tracker/tracker.component';
import { TripRatingDialogComponent } from './user-dashboard/trip-rating-dialog/trip-rating-dialog.component';
import { SuiModule } from 'ng2-semantic-ui';
import { DeliveryRatingDialogComponent } from './delivery-rating-dialog/delivery-rating-dialog.component';
import { CourierOnboardingComponent } from './admin-dashboard/courier-onboarding/courier-onboarding.component';
import { VendorService } from './vendor-portal/vendor.service';
import { ClientService } from './services/client-service/client.service';
import { HttpWrapperService } from './services/http-wrapper/http-wrapper.service';
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    BookRideComponent,
    SupportComponent,
    TrackingLinkComponent,
    StatusUpdateComponent,
    ClientLoginComponent,
    ClaimAccountComponent,
    RegisterComponent,
    RegistrationCompleteComponent,
    TermsComponent,
    DriverRegistrationComponent,
    PasswordResetComponent,
    DriverRouteComponent,
    AdminLoginComponent,
    GAuthorizationCallbackComponent,
    DriverGAuthorizationCallbackComponent,
    TrackerComponent,
    DeliveryRatingDialogComponent,
    CourierOnboardingComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpModule,
    FormsModule,
    BrowserAnimationsModule,
    CommonComponentsModule,
    MatButtonModule,
    MatCardModule,
    DialogModule,
    MatStepperModule,
    MatIconModule,
    MatToolbarModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatMenuModule,
    MatAutocompleteModule,
    MatSidenavModule,
    MatDatepickerModule,
    MatNativeDateModule,
    SharedModule,
    SuiModule,
    MatExpansionModule
  ],
  providers: [
    VehicleService,
    ApplicationUrlSettings,
    MainService,
    QuickAssignment,
    DirectionsService,
    UserService,
    CacheService,
    AuthService,
    SocketService,
    CompanyService,
    FileService,
    DriverService,
    VendorService,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    ClientService,
    HttpWrapperService
  ],
  entryComponents:[ DeliveryRatingDialogComponent ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts